<template>
  <div class="timeline-wrapper">
    <timeline>
      <timeline-item v-for="(item, index) in experience"
                     :key="index"
                     :line-color="'red'"
                     :hollow="true"
                     class="timeline-item">

        <img :src="item.icon" class="timeline-icon" slot="others" alt="icon"/>
        <p class="timeline-item-name">{{ item.name }}</p>
        <a :href="item.link" target="_blank" class="timeline-item-place link-purple">{{ item.place }}
          <img src="@/assets/img/icons/ic_website_black.svg" class="website-link" alt="website icon"/>
        </a>
        <p class="timeline-date">{{ item.date }}</p>
        <p v-if="item.description" v-html="item.description" class="timeline-description"></p>
      </timeline-item>
    </timeline>
  </div>
</template>

<script>
import {Timeline, TimelineItem} from 'vue-cute-timeline'
import {experience} from "@/utils/data/experience";

export default {
  name: "ResumeTimeline",
  components: {
    Timeline,
    TimelineItem,
    // TimelineTitle
  },
  data: () => ({
    experience
  })
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/base.mixins";
@import "~@/assets/css/base.variables";
@import "~@/assets/css/base.fonts";
@import "~@/assets/css/base.links";

.timeline-wrapper {
  margin-bottom: 50px;
  padding: 0 20px;
}

.timeline-item {
  @extend .font-roboto;
  border-bottom: none;

  &-name {
    font-size: 17px;
    font-weight: 900;
    line-height: 30px;
    margin-bottom: 5px;
  }

  &-place {
    @extend .italic-text;
    font-size: 14px;
    position: relative;

    &:hover {
      cursor: pointer;
    }
  }

  .timeline-icon {
    width: 30px;
  }

  .website-link {
    @include position(absolute);
    height: 15px;
    width: 15px;
  }

  .timeline-date {
    @extend .lato-gray;
    font-size: 14px;
    margin-top: 10px;
  }

  .timeline-description {
    @extend .font-lato;
    font-size: 15px;
    margin-top: 10px;
  }
}

@media screen and (min-width: $screen-md) {
  .timeline-wrapper {
    padding: 0 10%;
  }

  .timeline-item {
    &-name {
      font-size: 20px;
    }

    &-place {
      font-size: 16px;
    }

    .timeline-icon {
      width: 35px;
    }

    .website-link {
      width: 15px;
    }

    .timeline-date {
      font-size: 14px;
    }

    .timeline-description {
      font-size: 16px;
    }
  }
}
</style>
